import React from "react";

export default function Clients() {
  return (
    <>
      <div className="client-section mt--80 d-none d-md-block d-lg-block">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="customer-slider-wrap client-section-wrap text-center gray-light-bg shadow-lg p-5">
                <span className="shape-left"></span>
                <span className="shape-right"></span>
                <div className="text-center">
                  <p className="lead">
                    Estas son nuestras empresas 
                    <strong className="color-secondary font-weight-bold">
                    {" "} amigas
                    </strong>
                    .
                  </p>
                </div>
                <ul className="list-inline justify-content-between">
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/santander.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/aerolineasargentinas.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/assistravel.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/vittal.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/bariloche.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/cerrocatedral.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/camboriu.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/plusmar.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/sancor-seguos.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/visa.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/kuarzo.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/macro.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/jetsmart.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/sponsors/mercadopago.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
